function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "70px",
    height: "80px",
    viewBox: "0 0 70 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 15 C 0 12.238281 2.238281 10 5 10 L 65 10 C 67.765625 10 70 12.238281 70 15 C 70 17.765625 67.765625 20 65 20 L 5 20 C 2.238281 20 0 17.765625 0 15 Z M 0 40 C 0 37.234375 2.238281 35 5 35 L 65 35 C 67.765625 35 70 37.234375 70 40 C 70 42.765625 67.765625 45 65 45 L 5 45 C 2.238281 45 0 42.765625 0 40 Z M 65 70 L 5 70 C 2.238281 70 0 67.765625 0 65 C 0 62.234375 2.238281 60 5 60 L 65 60 C 67.765625 60 70 62.234375 70 65 C 70 67.765625 67.765625 70 65 70 Z M 65 70 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenMenu);
export default __webpack_public_path__ + "static/media/open-menu.254401a2cfdd0090bfbe47dcbc65c7ed.svg";
export { ForwardRef as ReactComponent };